module.exports = __webpack_public_path__ + "img/man.6be2b3c6.svg";